import {BucketCustomization, SemanticLegendSettings} from '../../types';

export function invertColors(semanticLegendSettings: SemanticLegendSettings) {
  const newBucketCustomizations: Record<number, BucketCustomization> = {};
  const buckets = semanticLegendSettings?.buckets;
  if (buckets) {
    for (let i = 0; i < buckets.length; i++) {
      const bucket = buckets[i];
      const bucketCustomization =
        semanticLegendSettings?.bucketCustomizations?.[i];
      let color = bucket.color;
      if (bucketCustomization) {
        color = bucketCustomization.color;
      }
      newBucketCustomizations[buckets.length - 1 - i] = {
        ...semanticLegendSettings?.bucketCustomizations?.[
          buckets.length - 1 - i
        ],
        color: color,
      };
    }
  }
  return {
    ...semanticLegendSettings,
    bucketCustomizations: newBucketCustomizations,
  };
}
